import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { DataEndChannelTypeEnum } from "src/app/project/shared/enums/data-end-channel-type.enum";
import { SetBarrierControl } from 'src/app/project/shared/interfaces/set-barrier-control';
import { BarrierPositionEnum } from 'src/app/device/shared/enums/barrier-position.enum';
import { BarrierPositioningCommand } from 'src/app/project/shared/enums/barrier-positioning-command.enum';
import { DataEndChannelService } from 'src/app/project/shared/services/data-end-channel.service';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';

@Component({
  selector: 'avs-set-barrier-control',
  standalone: false,
  templateUrl: './set-barrier-control.component.html',
  styleUrl: './set-barrier-control.component.css'
})
export class SetBarrierControlComponent implements OnInit {

  @Input() selectedBarrierChannel?: DataEndChannel; /*  */
  @Input() currentPositionCode: BarrierPositionEnum | undefined; /*  */
  @Input() blocked: boolean | undefined; /*  */


  public positionCode: BarrierPositionEnum | undefined;
  public blockedStatus: boolean | undefined;
  public commandSent: boolean = false;
  public positioningCommand: BarrierPositioningCommand = BarrierPositioningCommand.Schrankenantrieb_abgestellt;
  constructor(private dataEndChannelService: DataEndChannelService, private alertService: AlertService) {
  }

  ngOnInit(): void {
    /*this.parseChannelState();*/
    this.positionCode = this.currentPositionCode;
    this.blockedStatus = this.blocked;
    console.log('BarrierManControl: init with current code: '+this.positionCode+ ", blocked? "+ this.blockedStatus);
  }

  ngOnChanges(changes: SimpleChanges): void {
  console.log('BarrierManControl: OnChanges : channel: '+this.selectedBarrierChannel?.dataEndChannelType+
    ', position old '+ this.positionCode+ ', new '+ this.currentPositionCode +
    ', blocked old '+ this.blockedStatus+ ', new '+ this.blocked );   
    this.commandSent = false;    
    this.positionCode = this.currentPositionCode;
    this.blockedStatus = this.blocked;
  }

  public isStopEnabled(): boolean {
    return (!this.commandSent && !this.blockedStatus && (this.positionCode === BarrierPositionEnum.MovingToPos1Closed || this.positionCode === BarrierPositionEnum.MovingToPos2Open));
  }
  public isMoveToOpenEnabled(): boolean {
    return (!this.commandSent && !this.blockedStatus && (this.positionCode === BarrierPositionEnum.AtPos1Closed || this.positionCode === BarrierPositionEnum.UnknownStopped));
  }
  public isMoveToCloseEnabled(): boolean {
    return (!this.commandSent && !this.blockedStatus && (this.positionCode === BarrierPositionEnum.AtPos2Open || this.positionCode === BarrierPositionEnum.UnknownStopped));
  }
  
  public moveToOpen(): void {
      let barrierControl = {
        active: true,
        command: BarrierPositioningCommand.Nullstellung
    } as SetBarrierControl;

    this.setBarrierManualControl(barrierControl);
  }
  public moveToClose(): void {
      let barrierControl = {
        active: true,
        command: BarrierPositioningCommand.Sperrstellung
    } as SetBarrierControl;

    this.setBarrierManualControl(barrierControl);
  }
  public stopMoving(): void {
      let barrierControl = {
        active: true,
        command: BarrierPositioningCommand.Schrankenantrieb_abgestellt
    } as SetBarrierControl;

    this.setBarrierManualControl(barrierControl);
  }

  private setBarrierManualControl(barrierControl: SetBarrierControl): void {
    if (this.selectedBarrierChannel) {
      this.commandSent = true;
      this.dataEndChannelService.setBarrierManualControl(Number(this.selectedBarrierChannel.id), barrierControl).subscribe(resp => {
          this.alertService.alert('Schrankenkommando wurde übermittelt', AlertTypes.success);
        });
        console.log("setManualControl id: "+ Number(this.selectedBarrierChannel.id) +' new positioning command: '+ barrierControl.command);
    } else {
      this.alertService.alert('Fehler beim Schrankenkommando', AlertTypes.error);
    }
  }
}